import { PaginationProps, TableProps } from 'antd';
import { deleteApiWithData, getApi, postApi } from 'apis';
import { SideDrawerWrapper } from 'components/Global';
import ConfirmDelete from 'components/Global/confirmDeleteModel';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import AddUserBody from './AddUserBody';
import CustomTable from './CustomTable';
import styles from './index.module.scss';


const UsersTable = () => {

	// State variables
	const [drawerAnimation, setDrawerAnimation] = useState<boolean>(false);
	const [isSideDrawerOpen, setSideDrawerOpen] = useState<boolean>(false);
	const [roleOptions, setRoleOptions] = useState([]);
	const [search, setSearch] = useState('');
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(
		Number(localStorage.getItem('userTableSize')) || 10
	);
	const [filter, setFilter] = useState('');
	const [sort, setSort] = useState('');
	const [type, setType] = useState('asc');
	const [drawerInfo, setDrawerInfo] = useState({
		drawerTitle: 'Users',
	});
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [editSelectedUser, setEditSelectedUser] = useState<any>();
	const [totalUsers, setTotalUsers] = useState(0);
	const [userData, setUserData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false);
	const [isSearchCancel, setIsSearchCancel] = useState<boolean>(false);



	const removeDrawerFromDom = () => {
		setSideDrawerOpen(false);
	};

	const openDrawerHandler = () => {
		setDrawerInfo({ drawerTitle: 'Add User' });
		setDrawerAnimation(true);
		setSideDrawerOpen(true);
	};


	const closeDrawerByAnimation = () => {
		setEditSelectedUser(undefined); 
		setDrawerAnimation(false);
	};


	const performSearchHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setSearch(value);
		setPage(1);
		if(value.length > 0){
			setIsSearchCancel(true)
		}else{
			setIsSearchCancel(false)
		}
	};


	const showModal = () => {
		setIsModalOpen(true);
	};

	const setDrawerInfoHandler = (drawerTitle: any) => {
		setDrawerInfo({ drawerTitle });
	};

	const handleOk = () => {
		setIsModalOpen(false);
		setEditSelectedUser(null);
	};

	const handleCancel = () => {
		setIsModalOpen(false); // !isAddUserLoading &&
		setEditSelectedUser(null);
	};

	// Delete user
	const deleteHandler = async () => {
		if (editSelectedUser) {
			try {
				setIsDeleteLoading(true);
				const resp = await deleteApiWithData('/user', { deleteUserId: editSelectedUser.userCompanyRoleId });
				toastText(resp?.data?.message ?? 'User deleted successfully', 'success');
			} catch (error: any) {
				toastText(error.response?.data?.message ?? 'Something went wrong in delete user', 'error');
			} finally {
				setIsDeleteLoading(false);
				handleCancel();
				fetchUsers();
			}
		}
	};

	const reinviteUserAction = async (data: any) => {
		setIsLoading(true);
		try {
			await postApi('/user/reinvite-user', {
				reInviteUserId: data.userId,
			});
			toastText('User re-invited successfully', 'success');
		} catch (error) {
			toastText('Something went wrong in re-inviting user', 'error');
		} finally {
			setIsLoading(false);
		}
	};

	const fetchUsers = useCallback(async () => {
		setIsLoading(true);
		const query = {
			page: page,
			limit: limit,
			search: search,
			sort: sort,
			type: type,
			filter: filter
		};
		const res = await getApi('/user', query);
		setUserData(res?.data?.data);
		setIsLoading(false);
		setTotalUsers(res?.data?.total);
	}, [page, limit, search, type, sort, filter]);

	const handleTableChange: TableProps<any>['onChange'] = (
		pagination,
		filters,
		sorter
	) => {
		const sortOrder = Array.isArray(sorter)
			? sorter[0]?.order
			: sorter.order === 'ascend'
				? 'asc'
				: 'desc';
		setType(sortOrder as string);

		const sortField = Array.isArray(sorter)
			? sorter[0]?.field
			: sorter.field === 'name'
				? 'firstName'
				: sorter.field;
		setSort(sortField as string);
	};

	const onShowSizeChange: PaginationProps['onShowSizeChange'] = (
		current,
		pageSize
	) => {
		setPage(current);
		setLimit(pageSize);
	};


	useEffect(() => {
		fetchUsers();
	}, [limit, page, search, sort, type, filter]);

	const fetchRoles = async () => {
		try {
			const data: any = await getApi('/role');

			if (data.data.data) {
				const roles = data.data.data.map((role: any) => {
					return {
						id: role.id,
						name: role.roleName,
					};
				});
				setRoleOptions(roles);
			}
		} catch (err) {
			// toastText('Something went wrong in fetching roles', 'error');
		}
	};

	useEffect(() => {
		fetchRoles();
	}, []);
	// JSX
	return (
		<>
			<div className={styles['user-table']}>
				{/* <TableActionHeader title={'Users'}>
				</TableActionHeader> */}

				<CustomTable
					dataSource={userData}
					handleTableChange={handleTableChange}
					onShowSizeChange={onShowSizeChange}
					isLoading={isLoading}
					search={search}
					totalRecords={totalUsers}
					performSearchHandler={performSearchHandler}
					performFilterHandler={(value: any) => setFilter(value)}
					reinviteUserAction={reinviteUserAction}
					openDrawerHandler={openDrawerHandler}
					setDrawerInfoHandler={setDrawerInfoHandler}
					setEditSelectedUser={setEditSelectedUser}
					showModal={showModal}
					currentPage={page}
					pageSize={limit}
					isSearchCancel={isSearchCancel}
					setIsSearchCancel={setIsSearchCancel}
					setSearch={setSearch}
				/>
			</div>
			<ConfirmDelete
				handleCancel={handleCancel}
				handleOk={handleOk}
				isModalOpen={isModalOpen}
				deleteHandler={deleteHandler}
				isLoading={isDeleteLoading} //isLoading
			// isAddUserLoading={false} //isAddUserLoading
			/>
			{isSideDrawerOpen && (
				<SideDrawerWrapper
					isOpen={drawerAnimation}
					removeDrawerFromDom={removeDrawerFromDom}
					closeDrawerByAnimation={closeDrawerByAnimation}
					headerTitle={drawerInfo.drawerTitle}
					position="right"
					width="half"
				>
					<AddUserBody
						closeDrawerByAnimation={closeDrawerByAnimation}
						editSelectedUser={editSelectedUser}
						setEditSelectedUser={setEditSelectedUser}
						fetchUsers={fetchUsers}
						roleOptions={roleOptions}
					/>
				</SideDrawerWrapper>
			)}
		</>
	);
};

export default UsersTable;
